import { Component, NgModule, OnInit, OnDestroy, Input, Output, EventEmitter, HostListener, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Obligation } from 'app/shared/models/obligation.model';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { AddObligationComponent } from 'app/entities/transaction-profile/obligations/addobligation/add-obligation.component';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import { Agreement } from 'app/entities/transaction-profile/agreement.model';

@Component({
    selector: 'obligations',
    templateUrl: './obligation.component.html'
})

export class ObligationComponent implements OnInit, OnDestroy {
    @Input() entityIdDetails: EntityIdDetails;
    obligations: Array<Obligation>;
    dialogRef: MdDialogRef<any>;
    selectedObligation: Obligation;
    selectedAgreement: Agreement;
    isLoading = false;
    zeroAggrement = true;
    private subscriptions: Subscription[] = [];

    constructor(
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        public snackBarService:  SnackBarService,
        private transactionProfileService: EntityTransactionProfileService) { }

    ngOnInit() {
        this.setSelectedAgreementSubscriber();
    }

    setSelectedAgreementSubscriber() {
        // Unsubscribe from previous subscription if it exists
        const existingSub = this.subscriptions.find(sub => sub && !sub.closed);
        if (existingSub) {
            existingSub.unsubscribe();
        }
        
        this.isLoading = true;
        const subscription = this.transactionProfileService.selectedAgreement.subscribe(agreement => {
            if (agreement) {
                this.selectedAgreement = agreement;
                this.loadObligations();
                this.zeroAggrement = false;
            }else {
                this.isLoading = false;
            }
        });
        this.subscriptions.push(subscription);
    }

    loadObligations() {
        this.isLoading = true;
        const subscription = this.transactionProfileService.getObligations(this.selectedAgreement.id)
            .subscribe(response => {
                this.obligations = response;
                this.isLoading = false;
            });
        this.subscriptions.push(subscription);
    }

    editObligation(obligation: Obligation) {
        this.selectedObligation = obligation;
        this.openAddObligationDialog('Edit');
    }

    removeObligation(obligation: Obligation) {
        this.isLoading = true;
        const subscription = this.transactionProfileService.removeObligation(obligation.id)
            .subscribe(response => {
            this.loadObligations();
            this.callSnackBarService(response, MessageService.RIGHT_DELETE_SUCCESS, '');
        }, err => {
            this.callSnackBarService(err, '', MessageService.RIGHT_DELETE_FAILUR);
        });
        this.subscriptions.push(subscription);
    }

    callSnackBarService(response: any, success: string, failur: string) {
        this.isLoading = false;
        this.snackBarService.showStatus(response, success, failur);
    }

    openAddObligationDialog(action: string) {
        const config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddObligationComponent, config);
        this.dialogRef.componentInstance.selectedObligation = this.selectedObligation;
        this.dialogRef.componentInstance.entityIdDetails = this.entityIdDetails;
        this.dialogRef.componentInstance.agreementId = this.selectedAgreement.id;
        this.dialogRef.componentInstance.action = action;
        const subscription = this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadObligations();
            }
            this.dialogRef = null;
            this.selectedObligation = null;
            //setTimeout(() => { this.getGroupList() }, 2000)
        });
        this.subscriptions.push(subscription);
    }

    ngOnDestroy() {
        // Unsubscribe from all subscriptions to prevent memory leaks and duplicate calls
        this.subscriptions.forEach(sub => {
            if (sub && !sub.closed) {
                sub.unsubscribe();
            }
        });
        this.subscriptions = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/obligations/obligation.component.ts